import { Box, styled, Typography } from '@mui/material';

const Wrapper = styled(Box)(({ theme }) => ({
  backgroundColor: '#F1F1F1',
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(4.5, 7.5),
  borderRadius: theme.spacing(2),
  [theme.breakpoints.down('xl')]: {
    padding: theme.spacing(3.5, 5.5),
  },
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(3, 5),
  },
}));

const LeftSide = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

const MicrosoftImage = styled('img')(({ theme }) => ({
  width: theme.spacing(50),
  [theme.breakpoints.down('xl')]: {
    width: theme.spacing(42),
  },
  [theme.breakpoints.down('1360')]: {
    width: theme.spacing(38),
  },
  [theme.breakpoints.down('lg')]: {
    width: theme.spacing(36),
  },
  // [theme.breakpoints.down('lg')]: {
  //   width: theme.spacing(38),
  // },
}));

const TypographyProudToPartner = styled(Typography)(({ theme }) => ({
  fontSize: `${theme.spacing(5)} !important`,
  paddingBottom: theme.spacing(1.75),
  [theme.breakpoints.down('1680')]: {
    fontSize: `${theme.spacing(4.5)} !important`,
    paddingBottom: theme.spacing(1.75),
  },
  [theme.breakpoints.down('1360')]: {
    paddingBottom: theme.spacing(1),
    fontSize: `${theme.spacing(4)} !important`,
  },
  [theme.breakpoints.down('1200')]: {
    paddingBottom: theme.spacing(0.75),
    fontSize: `${theme.spacing(3.5)} !important`,
  },
}));
const TypographyMicrosoft = styled(Typography)(({ theme }) => ({
  fontSize: `${theme.spacing(7.5)} !important`,
  fontWeight: 600,
  [theme.breakpoints.down('xl')]: {
    // fontSize: theme.spacing(7),
  },
  [theme.breakpoints.down('1680')]: {
    fontSize: `${theme.spacing(6)} !important`,
  },
  [theme.breakpoints.down('1360')]: {
    fontSize: `${theme.spacing(5.25)} !important`,
  },
  [theme.breakpoints.down('1200')]: {
    fontSize: `${theme.spacing(5)} !important`,
  },
  [theme.breakpoints.down('1060')]: {
    fontSize: `${theme.spacing(4.5)} !important`,
  },
}));

const MicrosoftBanner = () => {
  return (
    <Wrapper>
      <LeftSide>
        <TypographyProudToPartner>
          Proud to partner with
        </TypographyProudToPartner>
        <TypographyMicrosoft>Microsoft for Startups</TypographyMicrosoft>
      </LeftSide>
      <MicrosoftImage src="/static/img/MS_Startups.webp" alt="Microsoft" />
    </Wrapper>
  );
};

export default MicrosoftBanner;
